export default __webpack_public_path__ + "static/media/AudiBG.fe0f1db4.jpg";